import React from 'react';
import QRCode from 'qrcode.react';
import ScreenShot from './components/screenshot';
import { BrowserView, MobileView } from 'react-device-detect';

import Footer from './components/footer';

class Home extends React.Component {
  render() {
	document.body.classList.remove('inner-page');
  	return (
  		<div>
  			{/* Navbar Section*/}
  			<nav className="navbar navbar-expand-lg  theme-nav fixed-top">
				<div className="container">
					<a className="navbar-brand main-title" href={`${process.env.PUBLIC_URL}/`}>
						<img src="assets/images/calist-logo-small.png" alt="Calist logo"/>
					</a>
					<div className="collapse navbar-collapse" id="mainmenu">
						<ul className="navbar-nav ml-auto" id="mymenu">

							<li className="nav-item">
								<a className="nav-link" href="#screenshots" > </a>
							</li>
						</ul>
					</div>
				</div>
			</nav>

  			{/* Home One Section Start */}
			<section className="slide-bg" id="home">
				<div className="animation-circle">
					<i></i>
					<i></i>
					<i></i>
				</div>
				<div className="container">
					<div className="row">
						<div className="col-md-6">
							<div className="d-flex-1">
								<div className="slide-text">
									<div>
										<h1>iPhone Calendar Themes</h1>
										<div className="row" style={{paddingTop: 10}}>
											<div className="col-md-7">
												<BrowserView>
													<a href="https://apps.apple.com/app/id1590186123">
														<img width={220} src="assets/images/apple_download.svg" alt="Download Clist at App Store" className="img-fluid"/>
													</a>
												</BrowserView>
												<MobileView>
													<a href="https://calist.co/link/Sohr">
														<img width={220} src="assets/images/apple_download.svg" alt="Download Clist at App Store" className="img-fluid"/>
													</a>
												</MobileView>
											</div>
											<div className="col-md-3 d-none d-md-block">
												<QRCode value="https://calist.co/link/Sohr" size={75}/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="home-right">
								<div className="mobile-slid">
									<img src="assets/images/themes/abstract_landmarks/calist_2022_calendar_abstract_landmarks_1.png" alt="top1" className="img-fluid"/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
  			{/* Home One Section End */}

			{/*ScreenShot Component*/}
			<ScreenShot />

			{/*Footer Component*/}
			<Footer />

			{/*tap-top*/}
			<div className="tap-top">
				<div>
					<i className="fa fa-angle-up" aria-hidden="true"></i>
				</div>
			</div>
  		</div>
  	);
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/home.js